import type { FaireProductEntity } from "../../entity_types/product";

export const p_26vp27rq7t: FaireProductEntity = {
  token: "p_26vp27rq7t",
  type: "product",
  name: "Lavender Self Care Gift Set – Calm Ritual Box",
  brandToken: "b_rn6fyv9g7w",
  brandName: "All Good Home & Body",
  imageUrl:
    "https://cdn.faire.com/fastly/9dbd2143f023fa9231ea13956c7736340a43ed256126a8d1c1d80a55523ded38.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/61a526705498c3635ae5b7547b6018ca3075479c0209c1ab0538d6085b2ecd84.png",
    "https://cdn.faire.com/fastly/73953eceac5eb20d3a1853ffdb6429e934d540d37665433d971a0219c0347d5e.png",
    "https://cdn.faire.com/fastly/ccf0dcd367c285364b3a34f2ee55fba7d3fac98ef2bd8ea7279f53c6bf6411ab.png",
    "https://cdn.faire.com/fastly/2a9ef9fb010fd51594b9d7f51c2a4e75ffc7df1b0ba7b6c07d31379366aa0a8a.png",
    "https://cdn.faire.com/fastly/8d2b34c4290101268e801ed5ef768ce55a83b960979da68f7ecbd841ab44ae9e.png",
  ],
  priceDollars: 26,
  description:
    "A thoughtfully curated self care set designed to create a calming, spa-like experience at home. This gift-ready bundle combines best-selling products from the Calm Collection, making it an ideal option for boutiques, gift shops, and wellness-focused retail spaces.\n\nFeaturing a balanced blend of lavender, eucalyptus, and rosemary, each item is designed to help customers slow down, reset, and enjoy simple daily rituals.\n\nThis set is especially popular as a ready-to-sell gift item, perfect for customers looking for meaningful, easy gifting options.\n\nWhat’s Included\n• 7 oz soy aromatherapy candle\n• Shower steamer (4 oz)\n• Roll-on perfume (10 ml)\n\nAll items feature the Calm scent profile.\n\nScent Profile\nLavender • Eucalyptus • Rosemary\nSoft, herbal, and spa-like\n\nWhy Retailers Love It\n• High-value, ready-to-sell gift set\n• Combines multiple best-selling categories\n• Strong margin opportunity\n• Ideal for holidays, gifting, and self care displays\n\nProduct Details\n• Gift-ready packaging\n• Handcrafted in small batches\n• Shelf-ready and easy to merchandise\n\nHandcrafted in Southern Indiana.",
  tags: [],
  msrpDollars: 42,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:53:12.318Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
